<template>
  <!-- 保障计划 -->
  <common-modal :is-show-close="isShowClose" @close="close">
    <div class="agree-wrap">
      <h1>保障计划</h1>
      <div class="agree-text">
        <p>1、订单处理周期为五天，超过处理时间，商家可以直接申请全额退还款项，系统审核后款项原路退回。</p>
        <p>2、订单处理期间，订单状态为“处理中”，表示订单正在处理，商家无故中途撤单，按<span @click="showAgreeMent">《用心淘下单协议》</span>只能退还50%支付款项，系统审核后款项原路退回。</p>
        <p>3、订单处理期间，订单状态变更为“未解决”，表示订单未处理成功， 商家可以直接申请全额退款，系统审核后款项原路退回。</p>
      </div>
    </div>
  </common-modal>
</template>

<script>
import commonModal from '@/components/commonModal.vue';
export default {

  components: {
    commonModal
  },
  data() {
    return {
      isShowClose: true
    }
  },

  methods: {
    close() {
      this.$emit('close')
    },

    showAgreeMent() {
      this.close();
		    this.$emit('showAgreeMent')
    }
  }
}
</script>

<style lang="scss" scoped>
    //补充资料
    .agree-wrap{
        h1{
            border-bottom: 1px solid #E9E9E9;
            padding: 15px;
            text-align:center;
            @include font-style;
            font-size: 20px;
            color: #000000;
        }
        .agree-text{
            box-sizing: border-box;
            padding: 40px;
            background: #FFFFFF;
            line-height:30px;
            letter-spacing: 2px;
            p{
                margin-bottom: 20px;
            }
            p:last-child{
                margin-bottom: 0;
            }
			span{
				@include cursor-style;
				color: rgb(65, 132, 244);
			}
        }
    }
</style>
